/*
 * Copyright 2025 Intuition Robotics ltd
 */
export const validateInternationalPhoneNumber = /^\+(?:[0-9] ?){6,14}[0-9]$/;
export const validateUSPhoneNumbers = /^\+1\d{10}$/;
export const validatorOfAlphaNumeric = /^[A-Z0-9]+$/i;
export const validatorOfNumeric = /^[0-9]+$/;
export const validatorOfAlphaNumericAndDashes = /^[A-Z0-9-]+$/i;
export const validatorOfLowerAlphaNumericAndUnderscores = /^[a-z0-9_]+$/;
export const validatorOfNumbersDashesAndPlusSignInBeginning = /^[+]?[0-9-]*$/
export const validatorOfEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const validatorOfSomSerial = /^[A-Z0-9]{18}$/;
export const validatorOfSOSerial = /^[a-z0-9]{32}$/;
export const validatorOfTabletSerial = /^\d{8}$/i;
export const validatorOf3p0 = /^ELQ30[A-Z0-9]{11}$/;
export const validatorOfAgentIdPrefix = /^[a-z0-9]+-[a-z0-9]+-$/;
